<div class="card card-custom gutter-b">
    <div class="card-header">
        <div class="card-title">
            <h3 class="card-label">Adauga Top Management</h3>
        </div>
    </div>
    <div class="card-body">
        <form #createManagement='ngForm' (ngSubmit)="createTopM(createManagement)">
            <div class="row">
                <div class="col-md-6 col-12">
                    <div class="form-group">
                        <label id="title">Titlu</label>
                        <input
                                type="text"
                                class="form-control"
                                name="title"
                                ngModel
                                placeholder="Titlu"
                                required
                                #title='ngModel'
                        />
                        <div class="error-msg"
                             *ngIf="!title.valid && (title.touched || createManagement.submitted)">
                            Acest camp este obligatoriu!
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="form-group">
                        <label for="topMCategories">Categorii</label>
                        <ng-select2 [data]="topMCategoriesData"
                                    [options]="multiOptions"
                                    id="topMCategories"
                                    ngModel
                                    name="topManagerCategories"
                                    required
                                    #topMCategories='ngModel'
                        >
                        </ng-select2>
                        <div class="error-msg"
                             *ngIf="!topMCategories.valid && (topMCategories.touched || createManagement.submitted)">
                            Acest camp este obligatoriu!
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="form-group">
                        <label for="description" class="m-0">Descriere</label>
                        <textarea class="form-control"
                                  id="description"
                                  ngModel
                                  name="description"
                        >
                        </textarea>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="form-group">
                        <label for="status" class="m-0">Status</label>
                        <select id="status" class="form-control" ngModel [(ngModel)]="defaultStatus" name="status"
                                required #status='ngModel'>
                            <option selected value="draft">Ciorna</option>
                            <option value="sent">Trimis</option>
                            <option value="accepted">Acceptat</option>
                            <option value="declined">Respins</option>
                        </select>
                        <div class="error-msg"
                             *ngIf="!status.valid && (status.touched || createManagement.submitted)">
                            Acest camp este obligatoriu!
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <h2>Lista Fisiere</h2>
                    <div class="row">
                        <div class="col-12">
                            <ng-template ngFor
                                         [ngForOf]="repeaterData.files"
                                         let-index="index"
                                         let-files
                                         ngModelGroup="files">
                                <div class="mb-2">
                                    <div class="row" ngModelGroup="{{index}}">
                                        <div class="col-md-11 col-12">
                                            <div class="form-group">
                                                <label class="m-0" for="linkFile">Fisier</label>
                                                <input type="file"
                                                       id="linkFile"
                                                       class="form-control"
                                                       name="link"
                                                       (change)="selectFile($event)"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-1 col-12 mt-6">
                                            <button (click)="removeFile( index )" type="button"
                                                    title="Remove Product" class="remove btn btn-danger"> X
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                            <p class="actions">
                                <button class="form-control add-repeater mb-10" type="button"
                                        (click)="addFile()"> Adauga Fisier
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <app-form-message [success]="formResponse" *ngIf="formSent"></app-form-message>
                    <button type="submit" class="btn btn-primary w-100">Adauga</button>
                </div>
            </div>
        </form>
    </div>
</div>
